@switch (variant) {
  @case ('fontawesome') {
    <fa-icon [icon]="iconSpinner" [animation]="'spin'" [size]="spinnerSize()" />
  }
  @case ('rocket') {
    <fmnts-rocket [size]="size" [color]="color" [animateThrusts]="true" />
  }
  @case ('donut') {
    <div
      class="flex justify-center items-center animate-spin"
      (click)="onDonutFound()"
    >
      <img
        src="assets/images/donut.webp"
        alt="Loading indicator"
        class="donut-{{ size }}"
      />
    </div>
  }
}
